export default __webpack_public_path__ + "static/media/gardenbeds-banner.ea611dc9.jpg";